import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PaybitoCaptcha from "../../Custom-component/PaybitoCaptcha";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { brokerDetailedInfo } = useSelector((state) => state);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [retypePasswordVisible, setRetypePasswordVisible] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [isMatched, setIsMatched] = useState(false);
  const captchaRef = useRef(null);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid, isSubmitting },
    getValues,
    trigger,
    setError,
    clearErrors,
  } = useForm();

  var frontPagebakgColor =
    "linear-gradient(90deg, " +
    brokerDetailedInfo?.color?.backgroundColor1 +
    " 0%, " +
    brokerDetailedInfo?.color?.backgroundColor2 +
    " 60%)";

  var backgroundStyle = "";

  if (brokerDetailedInfo?.color?.isBackgroundImage == 0) {
    // console.log('in if block');

    backgroundStyle = {
      background: frontPagebakgColor,
    };
  } else {
    // console.log('in else block');

    backgroundStyle = {
      backgroundImage: `url(${brokerDetailedInfo?.color?.backgroundImageLink})`,
      backgroundRepeat: `no-repeat`,
      backgroundSize: `cover`,
      backgroundPosition: `center`,
      minHeight: `100%`,
    };
  }

  useEffect(() => {
    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [countdown]);

  useEffect(() => {
    if (watch("retypePassword")) {
      if (watch("retypePassword") !== watch("newPassword")) {
        setError("retypePassword", {
          type: "manual",
          message: "Passwords do not match",
        });
        setIsMatched(false);
      } else {
        clearErrors("retypePassword");
        setIsMatched(true);
      }
    } else {
      // nothing typed yet
      setIsMatched(false);
      clearErrors("retypePassword");
    }
  }, [watch("retypePassword"), watch("newPassword"), setError, clearErrors]);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleRetypePasswordVisibility = () => {
    setRetypePasswordVisible(!retypePasswordVisible);
  };

  const inputStyle = {
    border: "none",
    borderBottom: "1px solid #999898",
    borderRadius: "0px",
    height: "40px",
    fontSize: "14px",
    padding: "5px",
    outline: "none", // Remove default outline
    boxShadow: "none", // Remove additional focus styling
  };

  const handleGetCode = async () => {
    const email = getValues("email");

    if (email == "") {
      showToast("error", "Please add the email id first");
    } else {
      console.log("Email:", email);
      // Handle get code logic here
      const response = await axios.post(
        `${WEBSERVICE}user/SendOtp/forgetpassword`,
        {
          email: email,
          brokerId: localStorage.getItem("BROKERID_Domain"),
        }
      );
      console.log("Response:", response);
      if (response?.data?.error?.error_data === 0) {
        setCountdown(300);
        showToast("success", "Secure token sent to your email");
      } else {
        showToast("error", response?.data?.error?.error_msg);
      }
    }
  };

  const onSubmit = async (data) => {
    console.log("Form Data:", data);
    try {
      const { token } = await captchaRef.current.verify();
      const payload = {
        email: data?.email,
        password: data?.newPassword,
        repassword1: data?.retypePassword,
        secureToken: data?.secureToken,
        gRecaptchaResponse: token,
      };
      const response = await axios.post(
        `${WEBSERVICE}user/ResetPassword`,
        payload
      );
      if (response?.data?.error?.error_data === 0) {
        showToast("success", "Password changed successfully");
        navigate("/login");
      } else {
        showToast("error", response?.data?.error?.error_msg);
      }
    } catch (error) {
      if (error.message !== "captcha-cancelled") {
        showToast("error", "Captcha verification failed");
      }
    }
  };

  const textFieldStyles = {
    mt: 1,
    input: {
      color: "#333",
      "&::placeholder": {
        color: "#aaa",
        opacity: 1,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& fieldset": {
        borderColor: "#ccc",
      },
      "&:hover fieldset": {
        borderColor: "#888",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1976d2",
      },
    },
    "& .MuiFormHelperText-root": {
      mt: 0.5,
    },
    "& label": {
      color: "#333",
      "&.Mui-focused": {
        color: "#1976d2",
      },
    },
  };

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@.!])[a-zA-Z\d$@.!]{8,35}$/;
  const passwordValue = watch("newPassword", "");
  // Check if user has started typing and regex not matched yet
  const showDynamicHint =
    passwordValue.length > 0 && !passwordRegex.test(passwordValue);

  return (
    <>
      <Box
        sx={{
          ...backgroundStyle,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <Container
          maxWidth="xs"
          sx={{ backgroundColor: "#fff", p: 4, borderRadius: 2, boxShadow: 3 }}
        >
          <Typography variant="h5" align="center" color="text.secondary" mb={3}>
            {localStorage.getItem("exchange")} - Reset Password
          </Typography>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              className="black-autofill"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Invalid email address",
                },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
              onBlur={() => trigger("email")}
              sx={textFieldStyles}
            />

            <TextField
              label="New Password"
              type={passwordVisible ? "text" : "password"}
              fullWidth
              margin="normal"
              className="black-autofill"
              {...register("newPassword", {
                required: "Password is required",

                pattern: {
                  value: passwordRegex,
                  message:
                    "Must contain uppercase, lowercase, number, and one special character ($ @ . !)",
                },
              })}
              error={!!errors.newPassword || showDynamicHint}
              helperText={
                errors.newPassword
                  ? errors.newPassword.message
                  : showDynamicHint
                  ? "The password should be of minimum 8, maximum 35 characters and must contain at least one uppercase, one lowercase, a number and a special character (only $ @ . ! are allowed in special characters)."
                  : ""
              }
              onBlur={() => trigger("newPassword")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setPasswordVisible(!passwordVisible)}
                      sx={{ color: "black" }}
                    >
                      {passwordVisible ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={textFieldStyles}
            />

            <TextField
              label="Retype New Password"
              type={retypePasswordVisible ? "text" : "password"}
              fullWidth
              margin="normal"
              {...register("retypePassword", {
                required: "Please retype your password",
                validate: (value) =>
                  value === watch("newPassword") || "Passwords do not match",
              })}
              error={!!errors.retypePassword}
              helperText={errors.retypePassword?.message}
              onBlur={() => trigger("retypePassword")}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setRetypePasswordVisible(!retypePasswordVisible)
                      }
                      sx={{ color: "black" }}
                    >
                      {retypePasswordVisible ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={textFieldStyles}
            />
            {isMatched && !errors.retypePassword && !showDynamicHint && (
              <Typography
                sx={{ color: "green", fontSize: "0.75rem", mt: "4px" }}
              >
                Passwords Matched
              </Typography>
            )}

            <Box display="flex" alignItems="center" mt={2}>
              <TextField
                label="Secure Token"
                type="number"
                fullWidth
                {...register("secureToken", {
                  required: "Secure token is required",
                })}
                error={!!errors.secureToken}
                helperText={errors.secureToken?.message}
                sx={textFieldStyles}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 8);
                }}
              />
              {countdown === 0 && (
                <Button
                  onClick={handleGetCode}
                  variant="contained"
                  // color="primary"
                  sx={{
                    ml: 2,
                    px: 2,
                    py: 0.5,
                    borderRadius: "20px",
                    textTransform: "none",
                    fontSize: "0.875rem",
                    boxShadow: "none",
                    minWidth: "100px",
                    color: "#fff",
                    mt: 1,
                    backgroundColor:
                      brokerDetailedInfo?.color?.buttonColor || "#1976d2",
                    "&:hover": {
                      backgroundColor:
                        brokerDetailedInfo?.color?.buttonColor || "#115293",
                    },
                  }}
                >
                  Get Code
                </Button>
              )}
            </Box>

            {countdown !== 0 && (
              <Typography variant="body2" color="text.secondary" mt={1}>
                Resend in {countdown} seconds
              </Typography>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={!isValid || isSubmitting} // 🚀 disable when invalid or submitting
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor:
                  brokerDetailedInfo?.color?.buttonColor || "#1976d2",
                "&:hover": {
                  backgroundColor:
                    brokerDetailedInfo?.color?.buttonColor || "#115293",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#b0b0b0", // gray for disabled state
                  color: "#ffffff", // white text on disabled
                },
                color: "#fff",
              }}
            >
              Change Password
            </Button>

            <Typography align="center">
              <a
                href="/login"
                style={{
                  textDecoration: "none",
                  color: "#0b57d0",
                  fontWeight: 600,
                }}
              >
                Back To Sign In
              </a>
            </Typography>
          </form>
        </Container>
      </Box>

      <PaybitoCaptcha ref={captchaRef} />
    </>
  );
};

export default ForgotPassword;
